<template>
    <div class="drawing-container">
        <div class="wrapper">
            <div class="choose-dimensions" v-if="!drawingReady" v-html="ui.t('backpanelChooseDimensions')"></div>

            <div class="backpanel" :style="panelStyles" v-if="drawingReady">
                <div class="dimensions">
                    <div class="length disabled" :class="{ focused: ui.focusedFieldName == 'backpanelLength' }">
                        <div class="title">
                            {{ ui.t("length") }} {{ ui.backpanelLength }}
                        </div>
                        <div class="bar horizontal"></div>
                    </div>

                    <div class="height disabled" :class="{ focused: ui.focusedFieldName == 'backpanelHeight' }">
                        <div class="title">
                            {{ ui.t("height") }} {{ ui.backpanelHeight }}
                        </div>
                        <div class="bar vertical"></div>
                    </div>
                </div>

                <div class="depth">
                    <div class="bg" :style="depthStyles"></div>
                    <div class="title">
                        {{ ui.t("thickness") }} {{ ui.backpanelStructure!.width }}
                    </div>
                    <div class="bar vertical"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script async setup lang="ts">
import { computed } from 'vue';
import { useUI } from '../store';

const containerLength: number = 4500;
const containerHeight: number = 1500;

const { ui } = useUI();

const drawingReady = computed(() => {
    return ui.backpanelLength! > 0 && ui.backpanelHeight! > 0;    
});

const panelStyles = computed(() => {
    return {
        width: (ui.backpanelLength! / containerLength * 100) + '%',
        height: (ui.backpanelHeight! / containerHeight * 100) + '%',
    }        
})

const depthStyles = computed(() => {
    return {
        height: ui.backpanelStructure!.width / 1.5 + 'px',
    }
});

</script>
